<template>
  <div>
    <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div class="sm:mx-auto sm:w-full sm:max-w-full">
        <div class="py-8 px-4 sm:px-10">
          <ApplyReferralNew :record="contact" :team="team" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApplyReferralNew from './ApplyReferralNew.vue';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';

export default {
  components: {
    ApplyReferralNew,
  },
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      selectedTab: 'Apply',
      team: {
        companyLogo: '',
        company: '',
      },
      contact: {
        name: '',
      },
      noJobFound: false,
    };
  },
  mounted() {
    this.getReferralDetails();
  },
  methods: {
    getReferralDetails() {
      const self = this;
      this.loadingSpinnerStore.showLoadingSpinner();
      fetch(`/public/apply_referral/${self.$route.params.id}`)
        .then(response => {
          this.loadingSpinnerStore.hideLoadingSpinner();
          return response.json();
        })
        .then(data => {
          self.contact.name = data.record.name;
          self.team.companyLogo = data.team.company_logo;
          self.team.company = data.team.company;
        });
    },
  },
};
</script>
